__turbopack_context__.v({
  "copy": "ShareGiveaway-module__5gnAVq__copy",
  "copy-text": "ShareGiveaway-module__5gnAVq__copy-text",
  "link-container": "ShareGiveaway-module__5gnAVq__link-container",
  "share-container": "ShareGiveaway-module__5gnAVq__share-container",
  "share-giveaway": "ShareGiveaway-module__5gnAVq__share-giveaway",
  "share-links-container": "ShareGiveaway-module__5gnAVq__share-links-container",
  "title": "ShareGiveaway-module__5gnAVq__title",
});
